// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"23f370a1","921":"93b0335e"}[chunkId] + ".chunk.js";
};